import React, { useImperativeHandle, useRef } from 'react';
import Events from 'events';
import classNames from 'classnames';

const ident = Symbol('OverlayOutlet');

const OverlayOutlet = React.forwardRef((props, ref) => {
  const elementRef = useRef();
  const eventsRef = useRef(new Events());
  const registryRef = useRef(new Map());
  const events = eventsRef.current;
  const registry = registryRef.current;

  useImperativeHandle(ref, () => ({
    __ident__: ident,

    elementRef,

    getHTMLElement() {
      return elementRef.current;
    },

    on(event, callback) {
      events.on(event, callback);
    },

    off(event, callback) {
      events.off(event, callback);
    },

    register(id, overlay) {
      registry.set(id, overlay);
      events.emit('overlayschange', {
        eventType: 'register',
        id,
        overlay
      });
    },

    unregister(id) {
      const overlay = registry.get(id);
      registry.delete(id);
      events.emit('overlayschange', {
        eventType: 'unregister',
        id,
        overlay
      });
    },

    getOverlays() {
      return Array.from(registry.values());
    },

    closeOverlays(...args) {
      if (registry && registry.values) {
        for (const overlay of registry.values()) {
          overlay.close(...args);
        }
      }
    }
  }));

  const classes = classNames({
    'up-overlay-outlet': true,
    [props.className]: !!props.className
  });

  return <div className={classes} ref={elementRef} />;
});

OverlayOutlet.ident = outletRef => {
  return outletRef && outletRef.__ident__ === ident;
};

export default OverlayOutlet;
